module.exports = __webpack_public_path__ + "media/images/Facebook-9720a15e145b4792c9f2ae7d000e755c.svg";